import { dietitianAccountQuery } from "@hooks/queries/settings/useFetchDietitianAccountQuery";
import { clientsQuery } from "@hooks/queries/useFetchClientsQuery";
import { queryClient } from "@services/queryClient";

export const homeLoader = async () => {
  const account = await queryClient
    .ensureQueryData(dietitianAccountQuery)
    .catch(() => null);
  if (account?.data?.clinic?.id)
    await queryClient.ensureQueryData(clientsQuery()).catch(() => null);
  return null;
};
